// extracted by mini-css-extract-plugin
export default {"NavBar":"Nav_NavBar__Fr780","Container":"Nav_Container__sew+8","LogoBtn":"Nav_LogoBtn__faemk","GoToPostPage":"Nav_GoToPostPage__9e+YY"};